import React from "react";
import ReactDOM from "react-dom/client";
import "mdb-react-ui-kit/dist/css/mdb.rtl.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import App from "./App";
import "./assets/styles/style.css";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import Store from "./Store/Store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<BrowserRouter basename={"/"}>
		<Provider store={Store}>
			<App />
		</Provider>
	</BrowserRouter>,
);
